/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FoundKnowledgeGraphValue from './FoundKnowledgeGraphValue';
import ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest from './ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest';

/**
 * The FindKnowledgeGraphValuesFromRelationshipsResponse model module.
 * @module model/FindKnowledgeGraphValuesFromRelationshipsResponse
 * @version 2.8.0
 */
class FindKnowledgeGraphValuesFromRelationshipsResponse {
    /**
     * Constructs a new <code>FindKnowledgeGraphValuesFromRelationshipsResponse</code>.
     * @alias module:model/FindKnowledgeGraphValuesFromRelationshipsResponse
     * @extends Object
     * @param requestReceived {Array.<module:model/ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest>} 
     * @param foundKnowledgeGraphValues {Array.<module:model/FoundKnowledgeGraphValue>} 
     */
    constructor(requestReceived, foundKnowledgeGraphValues) { 
        
        FindKnowledgeGraphValuesFromRelationshipsResponse.initialize(this, requestReceived, foundKnowledgeGraphValues);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, requestReceived, foundKnowledgeGraphValues) { 
        obj['requestReceived'] = requestReceived;
        obj['foundKnowledgeGraphValues'] = foundKnowledgeGraphValues;
    }

    /**
     * Constructs a <code>FindKnowledgeGraphValuesFromRelationshipsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FindKnowledgeGraphValuesFromRelationshipsResponse} obj Optional instance to populate.
     * @return {module:model/FindKnowledgeGraphValuesFromRelationshipsResponse} The populated <code>FindKnowledgeGraphValuesFromRelationshipsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FindKnowledgeGraphValuesFromRelationshipsResponse();

            ApiClient.constructFromObject(data, obj, 'Object');
            

            if (data.hasOwnProperty('requestReceived')) {
                obj['requestReceived'] = ApiClient.convertToType(data['requestReceived'], [ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest]);
            }
            if (data.hasOwnProperty('foundKnowledgeGraphValues')) {
                obj['foundKnowledgeGraphValues'] = ApiClient.convertToType(data['foundKnowledgeGraphValues'], [FoundKnowledgeGraphValue]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest>} requestReceived
 */
FindKnowledgeGraphValuesFromRelationshipsResponse.prototype['requestReceived'] = undefined;

/**
 * @member {Array.<module:model/FoundKnowledgeGraphValue>} foundKnowledgeGraphValues
 */
FindKnowledgeGraphValuesFromRelationshipsResponse.prototype['foundKnowledgeGraphValues'] = undefined;






export default FindKnowledgeGraphValuesFromRelationshipsResponse;

